import React, { FC, ReactNode } from 'react';
import dynamic from 'next/dynamic';

const MediaQuery = dynamic(() => import('react-responsive'), {
  ssr: false,
});

const MaxScreen: FC<{ children: ReactNode }> = ({ children }) => {
  return <MediaQuery minWidth={1400}>{children}</MediaQuery>;
};

export default MaxScreen;
